__turbopack_context__.v({
  "wrapper": "AuthorHeaderSocialMediaAccounts-module-scss-module__hoZQTq__wrapper",
});
